// App.tsx
import React from "react";
import { SnackbarProvider } from "notistack";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import theme from "./Constants/theme";
import { ThemeProvider } from "@mui/material";
import { SelectedCompanyProvider } from "./Contexts/SelectedCompanyContext";
import { WorkspaceColorProvider } from "./Contexts/WorkspaceColorContext";

import { BrowserRouter } from "react-router-dom";
import TokenConsumerProvider from "./Components/Common/TokenConsumerProvider";
import PushMessageListener from "./Components/Common/PushMessageListener";
import AppRoutes from "./Router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 15 * 60 * 1000,
      staleTime: 60 * 1000,
      retry: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <SelectedCompanyProvider>
            <WorkspaceColorProvider>
              <BrowserRouter>
                <TokenConsumerProvider>
                  <PushMessageListener />
                  <AppRoutes />
                </TokenConsumerProvider>
              </BrowserRouter>
            </WorkspaceColorProvider>
          </SelectedCompanyProvider>
        </SnackbarProvider>
      </ThemeProvider>
      <ReactQueryDevtools buttonPosition="bottom-right" />
    </QueryClientProvider>
  );
}

export default App;
